import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const UsersCreateView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { createUsers } = useSelector((state) => state.users);

  useEffect(() => {
    if (
      createUsers.status === CONSTANTS.STATUS.DONE
      && createUsers.type === 'USERS::CREATE_USER'
    ) {
      dispatch(actions.users.createUsers.redirect());
      navigate('/app/users');
    }
  }, [createUsers]);

  return (
    <Page className={classes.root} title="UsersCreateView">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xs={12}>
            {createUsers.status === CONSTANTS.STATUS.DONE || createUsers.status === null ? (
              <ProfileDetails />
            ) : (
              <LinearProgress />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default UsersCreateView;
